import request from '@/utils/seftRequest';

// 充值历史查询 /drm/ding/custService/queryRechargeHisBsnl
export function queryRechargeHisBsnl(data) {
  return request('/ding/custService/queryRechargeHisBsnl', {
    method: 'POST',
    body: data,
  });
}

// 图形验证码生成接口
export function genCaptcha() {
  return request('/ding/genCaptcha', {
    method: 'POST',
  });
}

// 根据号码查询账单信息
export function validCaptcha(data) {
  return request('/ding/validCaptcha', {
    method: 'POST',
    body: data,
  });
}

export function qryConfigParams(params) {
  return request('/ding/common/drmConfigItemParams', {
    params,
  });
}

// 原接口/whalecloud/cvbs/v1/RestGetReceiptFile
export function RestGetReceiptFile(body) {
  return request('/ding/custService/cvbs/v1/GetReceiptFile', {
    method: 'post',
    body,
  });
}
